export default "__VITE_ASSET__KRyNVRn0__"